<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    class="demo-ruleForm"
  >
    <el-form-item label="姓名" prop="name">
      <el-input v-model.trim="ruleForm.name"></el-input>
    </el-form-item>
    <el-form-item label="信箱" prop="email">
      <el-input v-model.trim="ruleForm.email" type="email"></el-input>
    </el-form-item>
    <el-form-item label="電話" prop="tel">
      <el-input v-model="ruleForm.tel" type="tel"></el-input>
    </el-form-item>
    <el-form-item label="地址" prop="address">
      <el-input v-model="ruleForm.address"></el-input>
    </el-form-item>
    <el-form-item label="購買方式" prop="payment">
      <el-select v-model="ruleForm.payment" placeholder="請選擇付款方式">
        <el-option label="WebATM" value="WebATM"></el-option>
        <el-option label="ATM" value="ATM"></el-option>
        <el-option label="CVS" value="CVS"></el-option>
        <el-option label="Barcode" value="Barcode"></el-option>
        <el-option label="Credit" value="Credit"></el-option>
        <el-option label="ApplePay" value="ApplePay"></el-option>
        <el-option label="GooglePay" value="GooglePay"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="備註" prop="message">
      <el-input type="textarea" v-model.trim="ruleForm.message"></el-input>
    </el-form-item>
    <el-form-item label="優惠卷" prop="coupon"
      >{{
        couponCode
          ? '可使用優惠碼: ' + couponCode
          : '沒有優惠碼可以去優惠專區抽取哦~'
      }}
      <el-input v-model.trim="ruleForm.coupon"></el-input>
    </el-form-item>
    <el-form-item class="d-flex justify-content-end">
      <el-button @click="resetForm('ruleForm')">清空資訊</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')"
        >訂單創建</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import apiFrontOrder from '@/assets/js/api/front/apiFrontOrder';
import { mapActions } from 'vuex';
export default {
  created() {
    this.$emit('insideChangeActive', 2);
    if (localStorage.getItem('couponCode')) {
      this.couponCode = localStorage.getItem('couponCode');
    }
  },
  data() {
    let checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error('請輸入信箱'));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error('請輸入正確格式'));
        }
      }, 100);
    };
    return {
      couponCode: '',
      ruleForm: {
        name: '',
        email: '',
        tel: '',
        address: '',
        payment: '',
        message: '',
        coupon: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: '請輸入姓名',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 5,
            message: '長度在 2 到 5 個字元',
            trigger: 'blur',
          },
        ],
        email: [{ required: true, validator: checkEmail, trigger: 'blur' }],
        tel: [
          {
            required: true,
            message: '請輸入電話',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^[0-9]{8,10}$/,
            message: '請輸入正確的電話號碼',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '請輸入地址',
            trigger: 'blur',
          },
        ],
        payment: [
          {
            required: true,
            message: '請選擇付款方式',
            trigger: 'change',
          },
        ],
        message: [
          {
            message: '請填寫備註',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(['setCartLength']),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          apiFrontOrder
            .post('', this.ruleForm)
            .then(res => {
              if (res.status === 200) {
                this.setCartLength();
                localStorage.removeItem('couponCode');
                localStorage.setItem('couponCode', res.data.data.code);
                this.$fire({
                  title: '訂單成立，是否前往結帳?',
                  type: 'success',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: '結帳',
                  cancelButtonText: '取消',
                }).then(result => {
                  if (result.value === true) {
                    this.$router.push({
                      name: 'shoppingstep3',
                    });
                    return;
                  }
                  this.$router.push({ name: 'products' });
                });
              }
            })
            .catch(err => {
              this.$fire({
                title: `${err}`,
                type: 'error',
                timer: 3000,
              });
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped></style>
